import axios from 'axios'

export default function({ commit, dispatch, rootState }, fileObj) {
    return axios.get(fileObj.url.replace('s3.amazonaws.com/', ''), {
        responseType: 'blob',
        headers: {
            'x-auth': rootState.auth.id
        }
    })
    .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileObj.name + '.' + fileObj.url.split('.').pop())
        document.body.appendChild(link)
        link.click()
        return true
    })
    .catch((error) => console.error(error))
}